import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ReservationsInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { name, reservationsInfo } = this.props;

    const splitPhoneNumber = (phoneNumber) => {
      let splittedPhoneNumber = phoneNumber;
      if (phoneNumber.includes('toll free')) {
        splittedPhoneNumber = phoneNumber.split(' toll free')[0];
      }

      return splittedPhoneNumber;
    };

    const sortedReservationsInfo = reservationsInfo.sort((a, b) => {
      if (a.country < b.country) { return -1; }
      if (a.country > b.country) { return 1; }
      return 0;
    });

    return (
      <React.Fragment>
        <div className="reservations_info--header">
          <h1>{name} - Reservations Support</h1>
        </div>
        <div className="reservations_info--grid">
          {reservationsInfo && sortedReservationsInfo.map(item => (
            <div className="reservations_info--content">
              <h1 className="country">{item.country}:</h1>
              <a href={`tel: ${splitPhoneNumber(item.telephone)}`} className="telephone"><FontAwesomeIcon icon={['fas', 'phone']} /> {item.telephone}</a>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}
